<!-- src/routes/home.svelte -->
<script>
  import { onMount } from 'svelte';
  import { set_meta } from '../lib/seo.js';
  import Hero from '../components/sections/Hero.svelte';
  import WhyItStalls from '../components/sections/WhyItStalls.svelte';
  import RealityCheck from '../components/sections/RealityCheck.svelte';
  import NewsletterCTA from '../components/sections/NewsletterCTA.svelte';
  import AboutTeaser from '../components/sections/AboutTeaser.svelte';

  onMount(() => {
    set_meta({
      title: 'Real, Measurable AI for Your Business — in Plain English',
      description: "You know your business needs more AI — you're just not sure how. Together we make real, measurable upgrades with the right tools and plain-English expertise.",
      path: '/'
    });
  });
</script>

<main>
  <Hero />
  <WhyItStalls />
  <RealityCheck />
  <NewsletterCTA />
  <AboutTeaser />
</main>
